module.exports = __webpack_public_path__ + "static/media/material-video.ce64b6d7.svg";